module.exports = __webpack_public_path__ + "img/user-times.fd644628.svg";